import constants from '@/app-configs/constants'

export default [
  {
    title: 'DEBTIA_DEBTORS',
    icon: 'UserIcon',
    action: constants.action.permissionDebtorView,
    resource: constants.resource.debtor,
    companyOnly: true,
    route: 'debtors-list',
  },
]
